export default "__VITE_ASSET__COzMH_UB__"